import React, { useState } from "react";
import {
  Button,
  Modal,
  Container,
  Row,
  Col,
  Alert,
  Form,
} from "react-bootstrap";

function EditServicioModal({ updateServicio, servicioEditando }) {
  // States del Modal
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  // clean state
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // States de los campos del form.
  const [servicio, setServicio] = useState(servicioEditando.servicio);
  const [prC, setPrC] = useState(servicioEditando.prC);
  const [prSL, setPrSL] = useState(servicioEditando.prSL);
  const [prL, setPrL] = useState(servicioEditando.prL);
  const [prCT, setPrCT] = useState(servicioEditando.prCT);
  const [prSLT, setPrSLT] = useState(servicioEditando.prSLT);
  const [prLT, setPrLT] = useState(servicioEditando.prLT);

  // Funcion encargada de poner en mayuscula campos importantes
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  // Funcion encargada de tomar los datos del form y editar un servicio en la DB.
  async function handleEdit() {
    const servicioModificado = {
      servicio: capitalizeFirstLetter(servicio),
      prC: prC,
      prSL: prSL,
      prL: prL,
      prCT: prCT,
      prSLT: prSLT,
      prLT: prLT,
    };
    // Verificamos que todos los campos del form estan completos
    if (
      servicioModificado.servicio !== "" &&
      servicioModificado.prC !== "" &&
      servicioModificado.prSL !== "" &&
      servicioModificado.prL !== "" &&
      servicioModificado.prCT !== "" &&
      servicioModificado.prSLT !== "" &&
      servicioModificado.prLT !== ""
    ) {
      // Aca tenemos que llamar a la funcion que va a hacer el servicio de editar al Servicio en el back y le pasamos los datos.
      updateServicio(servicioEditando.id, servicioModificado);
      handleClose();
    } else {
      setError(true);
    }
  }

  // Funcion encargada de volver a cargar los valores originales en cada input del formulario cuando se cancela el edit.
  const handleCancel = () => {
    setServicio(servicioEditando.servicio);
    setPrC(servicioEditando.prC);
    setPrSL(servicioEditando.prSL);
    setPrL(servicioEditando.prL);
    setPrCT(servicioEditando.prCT);
    setPrSLT(servicioEditando.prSLT);
    setPrLT(servicioEditando.prLT);
    setError(false);

    handleClose();
  };

  return (
    <>
      <Button className="m-1" variant="warning" size="sm" onClick={handleShow}>
        Editar
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton onClick={handleCancel}>
          <Modal.Title>Editar servicio: "{servicio}"</Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid">
          <Container>
            {error && (
              <Alert variant="danger">Debe completar todos los campos!</Alert>
            )}
            <Row>
              <Col xs={12} md={12}>
                <Form.Group
                  onChange={(e) => {
                    setServicio(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Servicio:</Form.Label>
                  <Form.Control
                    type="text"
                    required={true}
                    defaultValue={servicio}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setPrC(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Pelo Corto:</Form.Label>

                  <Form.Control type="number" defaultValue={prC} />

                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setPrSL(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Pelo Medio:</Form.Label>

                  <Form.Control type="number" defaultValue={prSL} />

                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setPrL(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Pelo Largo:</Form.Label>

                  <Form.Control type="number" defaultValue={prL} />

                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setPrCT(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Corto con Tarjeta:</Form.Label>

                  <Form.Control type="number" defaultValue={prCT} />

                </Form.Group>
              </Col>

              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setPrSLT(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Medio con Tarjeta:</Form.Label>

                  <Form.Control type="number" defaultValue={prSLT} />

                </Form.Group>
              </Col>
              <Col xs={12} md={4}>
                <Form.Group
                  onChange={(e) => {
                    setPrLT(e.target.value);
                  }}
                  className="mb-3"
                >
                  <Form.Label>Largo con Tarjeta:</Form.Label>

                  <Form.Control type="number" defaultValue={prLT} />

                </Form.Group>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-danger" size="sm" onClick={handleCancel}>
            Cancelar
          </Button>
          <Button
            onClick={() => handleEdit()}
            variant="outline-success"
            size="sm"
          >
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default EditServicioModal;
